import ZoneForm from '@/components/zones/ZoneForm'
import { SharedProps, Zone } from '@/types'
import { Head, router } from '@inertiajs/react'
import { Container, Paper, Stack, Title } from '@mantine/core'

type ZoneFormValues = Pick<Zone, 'name' | 'service_days'>

interface EditZonePageProps extends SharedProps {
  zone: Zone
}

export default function EditZonePage({ zone, current_organization }: EditZonePageProps) {
  const handleUpdateZone = (values: ZoneFormValues) =>
    router.put(`/organizations/${current_organization!.slug}/zones/${zone.id}`, { zone: values })

  return (
    <>
      <Head title={`Modifier ${zone.name} - ${current_organization?.name}`} />

      <Container size="sm">
        <Stack gap="xl">
          <Title>Modifier la zone</Title>

          <Paper withBorder radius="md" p="md">
            <ZoneForm
              onSubmit={handleUpdateZone}
              initialValues={{ name: zone.name, service_days: zone.service_days }}
              submitLabel="Mettre à jour la zone"
            />
          </Paper>
        </Stack>
      </Container>
    </>
  )
}
